import React, { Component } from 'react';
import Button from 'components/button';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import enhance from '../enhance';
import { fadeInTime } from './select-default.css';
import './select-default.css';

class SetDefault extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
    this.setDefault = this.setDefault.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.defaultContentId !== nextProps.defaultContentId) {
      this.setState({ loading: false });
    }
  }

  setDefault() {
    this.props.updateDefaultContentId();
    this.setState({ loading: true });
  }

  render() {
    const isDefault =
      this.props.defaultContentId === this.props.selectedContentId;
    return (
      <div style={{ width: '100%', height: '185px' }}>
        <div style={{ fontWeight: 100, textAlign: 'center' }}>
          Select this content to play when none is scheduled
        </div>
        <div style={{ margin: 'auto', position: 'relative', width: '142px' }}>
          <ReactCSSTransitionGroup
            transitionName="appear"
            transitionEnterTimeout={parseInt(fadeInTime)}
            transitionLeaveTimeout={parseInt(fadeInTime)}
          >
            {isDefault
              ? <Button noBackground key="1">
                  <i className="green icon check" /> Default Set
                </Button>
              : <Button
                  key="2"
                  onClick={this.setDefault}
                  disabled={this.state.loading}
                >
                  SET DEFAULT
                </Button>}
          </ReactCSSTransitionGroup>
        </div>
      </div>
    );
  }
}

export default enhance(SetDefault);



// WEBPACK FOOTER //
// ./src/components/create/set-default/index.js